module.exports = __webpack_public_path__ + "img/passport-bg-omni.a4538599.png";